import { Authenticator } from "@aws-amplify/ui-vue"
import "@aws-amplify/ui-vue/styles.css"

import { Amplify } from 'aws-amplify'

function userpool_client_id() {
  if (window.location.host.includes('localhost')) {
    return '6mqdrruaggqf0gq3djal01eisb'
  }
  return '1nhnfci3vs6j2i7jhekisg9c7t'
}

function userpool_id() {
  if (window.location.host.includes('localhost')) {
    return 'eu-central-1_4s0qr90D7'
  }
  return 'eu-central-1_a68mXT8gf'
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: userpool_client_id(),
      userPoolId: userpool_id(),
      loginWith: {
        username: false,
        email: true,
      }
    }
  }
})

export default Authenticator
